module.exports = __webpack_public_path__ + "img/10b.3a6ff8ff.jpg";